import React, { useState } from 'react';
import { Grid, Segment, Form, Button, Message } from 'semantic-ui-react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import SemanticField from '../../app/common/form/SemanticField';

const validationSchema = Yup.object({
  name: Yup.string().required('Obrigatóriu'),
  email: Yup.string().email('Email la válidu').required('Obrigatóriu'),
  message: Yup.string().required('Obrigatóriu'),
});

const ContactPage = () => {
  const [success, setSuccess] = useState(false);
  const [serverError, setServerError] = useState('');

  if (success) {
    return (
      <Grid>
        <Grid.Row centered>
          <Grid.Column width={8}>
            <Message positive>
              <Message.Header>Obrigado!</Message.Header>
              <p>Ita-nia mensajen haruka ona. Ami sei kontaktu Ita lalais.</p>
            </Message>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  return (
    <Grid>
      <Grid.Row centered>
        <Grid.Column width={8}>
          <Segment.Group>
            <Segment attached='top'>
              <h3>Join the network</h3>
              <p style={{ color: '#666', marginTop: 4 }}>
                Kontaktu ami hodi sai parte husi rede Rai Disputa.
              </p>
            </Segment>
            <Segment attached='bottom'>
              <Formik
                initialValues={{ name: '', email: '', organization: '', message: '' }}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting }) => {
                  setServerError('');
                  fetch('/api/contact', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(values),
                  })
                    .then(async (res) => {
                      const data = await res.json();
                      if (!res.ok) throw new Error(data.message || 'Erru');
                      setSuccess(true);
                    })
                    .catch((err) => {
                      setServerError(err.message);
                      setSubmitting(false);
                    });
                }}
              >
                {({ handleSubmit, isSubmitting, isValid, dirty }) => (
                  <Form onSubmit={handleSubmit}>
                    {serverError && (
                      <Message negative>
                        <p>{serverError}</p>
                      </Message>
                    )}
                    <Form.Group widths='equal'>
                      <SemanticField
                        label='Naran (Name) *'
                        name='name'
                        component={Form.Input}
                      />
                      <SemanticField
                        label='Email *'
                        name='email'
                        component={Form.Input}
                      />
                    </Form.Group>
                    <SemanticField
                      label='Organizasaun (Organization)'
                      name='organization'
                      component={Form.Input}
                    />
                    <SemanticField
                      label='Mensajen (Message) *'
                      name='message'
                      component={Form.TextArea}
                      rows={5}
                    />
                    <Button
                      primary
                      type='submit'
                      content='Haruka mensajen'
                      disabled={isSubmitting || !isValid || !dirty}
                      loading={isSubmitting}
                    />
                  </Form>
                )}
              </Formik>
            </Segment>
          </Segment.Group>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default ContactPage;
